import { validateAndTrimString } from "core-lib/utils/utils";

export const calculateSavings = (amount: number, cashbackPercent = 0) => {
  // 2% (parkplusPetrol) + 2% (surchargeSavings) + 2% (cashback) = 6%
  const totalCashback = amount * (cashbackPercent / 100);
  const totalSavings =
    0.04 * amount + (totalCashback <= 150 ? totalCashback : 150);

  return Math.round(totalSavings);
};

export const setImageUrl = (file: string, type: 1 | 2 = 1) => {
  // @TODO: temp check while BE fixes its error, to be removed
  if (Array.isArray(file)) {
    file = file[0];
  }
  let newFile = file;
  const magentoHost = "https://store-images-cdn.parkplus.io";
  const s3Url = "https://s3.ap-south-1.amazonaws.com/parkplus-magento-images";
  const pubMedia = "/pub/media";

  if (newFile?.includes("http")) {
    if (newFile.includes(s3Url)) {
      return newFile.replace(s3Url, magentoHost);
    }
    return newFile;
  }
  if (newFile) {
    if (type === 1) {
      if (newFile.includes(pubMedia)) {
        newFile = newFile.replace(pubMedia, "");
      } else {
        newFile = `/product${newFile}`;
      }
    } else if (type === 2) {
      newFile = newFile.replace(pubMedia, "");
    }
    if (!newFile.includes("catalog"))
      return (newFile = `${magentoHost}/catalog${newFile}`);

    return `${magentoHost}${newFile}`;
  }
};

export const calculateDiscount = (
  listingPrice: number,
  sellingPrice: number
) => {
  const discount = Math.ceil(
    ((listingPrice - sellingPrice) / listingPrice) * 100
  );
  if (discount > 0) {
    return `${discount}% off`;
  }
};

export const getFirstAndLastName = (text: string) => {
  const temp = validateAndTrimString(text)
    .trimmedStr?.split(" ")
    .filter((item) => item !== "");

  const firstName = temp[0] || "";
  const lastName = temp.length > 1 ? temp?.slice(1)?.join(" ") : "";

  return {
    firstName,
    lastName,
  };
};
